<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
// Template SFC — PRESENTATION ONLY (DEV-1135 template purity contract).
defineProps<{
  question: {
    id: string;
    title: string;
    answers: [string, string, string?, string?, boolean?][];
  };
  selected: string[];
}>();
</script>

<template>
  <div class="tpl-pdt__question">
    <h2 class="tpl-pdt__question-title">{{ question.title }}</h2>
    <div class="tpl-pdt__answers">
      <button
        v-for="answer in question.answers"
        :key="answer[0]"
        type="button"
        class="tpl-pdt__answer"
        :class="{ 'tpl-pdt__answer--selected': selected.includes(answer[0]) }"
        @click="$emit('answer', answer)"
      >
        <span class="tpl-pdt__radio" aria-hidden="true"></span>
        <span class="tpl-pdt__answer-text">{{ String(answer[1]) }}</span>
      </button>
    </div>
  </div>
</template>
